export default __webpack_public_path__ + "static/media/ArcadiusStationary.7341d996.jpg";